"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _events = require("../../utils/events");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PlusIcon = function PlusIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.005 3a1 1 0 0 1 1 1v7.01H20a1 1 0 1 1 0 2h-6.995V20a1 1 0 1 1-2 0v-6.99H4a1 1 0 1 1 0-2h7.005V4a1 1 0 0 1 1-1z"
  }));
};
PlusIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "new-page": "AddPageButton__new-page__q_wqJ",
  "newPage": "AddPageButton__new-page__q_wqJ",
  "label": "AddPageButton__label__2M6cZ",
  "disabled": "AddPageButton__disabled__aRjl5",
  "enabled": "AddPageButton__enabled__3qrfC"
}; 
require('./AddPageButton.css');
var AddPageButton = /*#__PURE__*/function (_React$PureComponent) {
  function AddPageButton() {
    (0, _classCallCheck2.default)(this, AddPageButton);
    return _callSuper(this, AddPageButton, arguments);
  }
  (0, _inherits2.default)(AddPageButton, _React$PureComponent);
  return (0, _createClass2.default)(AddPageButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        ariaLabel = _this$props.ariaLabel,
        disabled = _this$props.disabled,
        label = _this$props.label,
        onClick = _this$props.onClick;
      return /*#__PURE__*/_react.default.createElement("div", {
        tabIndex: 0,
        "data-test-id": "add-new-page-button",
        role: "button",
        "aria-label": ariaLabel,
        className: (0, _classnames.default)(disabled ? styles.disabled : styles.enabled, styles.newPage),
        onClick: disabled ? null : onClick,
        onKeyDown: disabled ? null : (0, _events.onEnterKey)(onClick)
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        size: "xs"
      }, /*#__PURE__*/_react.default.createElement(PlusIcon, null)), /*#__PURE__*/_react.default.createElement("span", {
        className: styles.label
      }, label));
    }
  }]);
}(_react.default.PureComponent);
(0, _defineProperty2.default)(AddPageButton, "defaultProps", {
  ariaLabel: null,
  label: 'Add new page',
  disabled: false,
  onClick: null
});
var _default = exports.default = AddPageButton;
//# sourceMappingURL=AddPageButton.js.map